export const mutations = {
  setOrcamento(state, orcamento) {
    state.orcamento = orcamento;
  },
  setOrcamentos(state, orcamento) {
    state.orcamentos = orcamento;
  },
  setModalCadastroOrcamento(state, status) {
    state.modalCadastroOrcamento = status;
  },
  setModalExcluirOrcamento(state, status) {
    state.modalExcluirOrcamento = status;
  },
  addItemOrcamento(state, data) {
    state.itensOrcamento.push(data);
  },
  removeItemOrcamento(state, item) {
    let indice = state.itensOrcamento.indexOf(item);
    state.itensOrcamento.splice(indice, 1);
  },
  setItemOrcamento(state, item) {
    state.itemOrcamento = item;
  },
  setItensOrcamento(state, data) {
    state.itensOrcamento = data;
  },
  setModalPesquisarProdutosOrcamento(state, status) {
    state.modalPesquisarProdutosOrcamento = status;
  },
  setModalImprimirOrcamento(state, status) {
    state.modalImprimirOrcamento = status;
  },
  setModalEnviarEmailOrcamento(state, status) {
    state.modalEnviarEmailOrcamento = status;
  },
  setModalInfoProposta(state, status) {
    state.modalInfoProposta = status;
  },
  setInfoProposta(state, data) {
    state.infoProposta = data;
  }
};

export default {};
